import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Hook pour générer des liens avec préfixe langue automatique
 * Utilisation: const link = useLocalizedLink('/shop') → '/fr/shop'
 */
export const useLocalizedLink = () => {
  const { language } = useLanguage();
  
  const localizeLink = (path: string): string => {
    // Nettoyer le path
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    
    // Vérifier si déjà préfixé
    if (/^\/(fr|en|es|de|it)\//.test(cleanPath)) {
      return cleanPath;
    }
    
    // Ajouter préfixe langue
    return `/${language}${cleanPath}`;
  };
  
  return { localizeLink, language };
};
